<div
    ngClass="approval-flow-chip"
    [ngStyle]="{ 'background-color': getStatusColor(status) }">
    {{ label }}
</div>
